module.exports = __webpack_public_path__ + "img/sj.ed02ec41.png";